import type { FareSliceDetails } from "redmond";

export const getPlaneInfo = (fareSliceDetails?: FareSliceDetails): string => {
  if (!fareSliceDetails) return "";

  // TODO: we're only showing plane info for one segment slice AKA nonstop for now
  // due to the scenario where multiple segments might have different plane info and BE doesn't differentiate them
  if (fareSliceDetails.fareDetails.segments.length !== 1) {
    return "";
  }

  return (
    fareSliceDetails.amenitiesUtas?.amenities?.aircraft?.info?.displayText || ""
  );
};
